module.exports = __webpack_public_path__ + "static/logo-thewitcher-light-pl@2x-14f99445979245c0a2838911754d6dea.png";